import React from 'react'

function whatsnew() {
  return (
    <>
  <head>
    <meta charset="UTF-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>Whats New</title>
    <link rel="stylesheet" href="<%= process.env.APP_URL %>/css/main.css"/>
    <link rel="preconnect" href="https://fonts.googleapis.com"/>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
    <link href="https://fonts.googleapis.com/css2?family=K2D:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap" rel="stylesheet"/>
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
   
     <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"/>
     <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM" crossorigin="anonymous"></script>
    </head>
    <body></body>
    <body>
    <main>
        <section class="wrapper-body">

          
            
                <div class="container">
                    <div class="row wrapper-container mb-4">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body"> 
                                    
                                    <ol>
                                        <li>
                                            <h5>Introduction</h5>
                                            <p>Welcome to SwizzlePay ("we", "our", "us"). We are committed to protecting your privacy and ensuring that your personal data is handled in a safe and responsible manner. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our application SwizzlePay (the "Application"). Please read this policy carefully.</p>
                                        </li>
                                        <li>
                                            <h5>Information We Collect</h5>
                                            <h6>Personal Data</h6>
                                            <p>We may collect personal information that you provide directly to us, such as:</p>
                                            <ul>
                                                <li>Name</li>
                                                <li>Email address</li>
                                                <li>Phone number</li>
                                                <li>Payment information</li>
                                            </ul>
                                            <h6>Usage Data</h6>
                                            <p>We may also collect information about your interactions with our Application, including:</p>
                                            <ul>
                                                <li>IP address</li>
                                                <li>Device information</li>
                                                <li>Browser type</li>
                                                <li>Pages visited</li>
                                                <li>Time spent on pages</li>
                                            </ul>
                                        </li>
                                        <li>
                                            <h5>How We Use Your Information</h5>
                                            <p>We use the information we collect for various purposes, including:</p>
                                            <ul>
                                                <li>Providing and maintaining our Application</li>
                                                <li>Processing transactions and managing payments</li>
                                                <li>Sending you updates, notifications, and marketing communications</li>
                                                <li>Improving our Application and services</li>
                                                <li>Analyzing usage trends and preferences</li>
                                            </ul>
            
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center mt-3">
                            <small>&copy; {new Date().getFullYear()} SwizzlePay. All rights reserved.</small>
                        </div>
                    </div>
                </div>
            
            </section>
            
            
    </main>
    
</body>
</>
  )
}

export default whatsnew